import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';

import {
  border,
  space,
  color,
  position,
} from 'styled-system';

import Icon from '../Icons/Icon';

import Typography from '../Typography/Typography';

const Alert = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 14px;

  border: solid 2px;

  ${position};
  ${color};
  ${space};
  ${border};
`;

const StyledAlert = ({
  children,
  variant,
  theme,
  closeAlert,
  typographyProps,
  ...rest
}) => {
  const variantProps = variant !== 'unset' ? (theme.alerts[variant] || theme.alerts.primary) : {};

  return (
    <Alert
      {...variantProps.background}
      {...rest}
    >
      <Typography
        block
        width='100%'
        variant='button'
        {...variantProps.typography}
        {...typographyProps}
      >
        {children}
      </Typography>

      {closeAlert && (
        <Icon
          onClick={closeAlert}
          icon='times'
          color={(variantProps.typography || {}).color}
        />
      )}
    </Alert>
  );
};

StyledAlert.propTypes = {
  theme: PropTypes.object.isRequired,
  children: PropTypes.any,
  typographyProps: PropTypes.object,
  variant: PropTypes.string,
  fontColor: PropTypes.string,
  closeAlert: PropTypes.func,
};

StyledAlert.defaultProps = {
  children: null,
  typographyProps: {},
  variant: 'primary',
  fontColor: 'white',
  closeAlert: () => {},
};

export default withTheme(StyledAlert);
